import { render, staticRenderFns } from "./PcActivityHeader.vue?vue&type=template&id=5b4edcc3&scoped=true&"
import script from "./PcActivityHeader.vue?vue&type=script&lang=js&"
export * from "./PcActivityHeader.vue?vue&type=script&lang=js&"
import style0 from "./PcActivityHeader.vue?vue&type=style&index=0&id=5b4edcc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4edcc3",
  null
  
)

export default component.exports